import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-fail',
  templateUrl: './payment-fail.component.html',
  styleUrl: './payment-fail.component.scss'
})
export class PaymentFailComponent {

}
